import axios from 'axios';
import { isLocalhost } from '@@/scripts/siteutils';
import { getBaseHref } from '@@/utils/baseHref';

export interface IAppConfig {
  BASE_URL?: string;
  HOST_NAME?: string;
  MOCK_API?: boolean;
  MICROSOFT_CLIENT_ID?: string;
  // Written by plugins/set-partner.sh; surfaced in the environment banner.
  PARTNER_NAME?: string;
  ERROR?: boolean;
}

let appConfig: IAppConfig = {};

const setAppConfig = (env?: IAppConfig): void => {
  if (env) {
    appConfig = {
      ...appConfig,
      ...env,
    };
  } else {
    appConfig = {};
  }
};

const checkConfigValue = (key: keyof IAppConfig, value: IAppConfig[keyof IAppConfig]): boolean => {
  return appConfig?.[key] === value;
};

const loadExternalConfig = (): Promise<void> =>
  new Promise((resolve, reject) => {
    const base = getBaseHref().replace(/\/$/, '');
    let configURL = `${base}/static/config.json`;

    if (isLocalhost() && (window as Window & { IS_PRODUCTION?: boolean }).IS_PRODUCTION) {
      configURL = `${base}/config.json`;
    }

    axios
      .get<IAppConfig>(configURL)
      .then((response) => {
        if (response.status === 200) {
          const { data } = response;
          if (typeof data === 'object') {
            setAppConfig(data);
          } else {
            return reject(new Error('Config is broken'));
          }
        } else {
          return reject(new Error('Did not find brand config to override vars'));
        }
        return resolve();
      })
      .catch((error: unknown) => {
        console.info('Error loading config', error);
        appConfig.ERROR = true;
        reject(new Error(String(error)));
      });
  });

export { appConfig, setAppConfig, loadExternalConfig, checkConfigValue };
